import { Button, EventCodelessIcon } from 'tuui';
import { FormField } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './noEvents.module.scss';

export const NoEvents = ({ onStartCreate }) => {
    return (
        <div className={styles['container']}>
            <EventCodelessIcon className={styles['icon']} />
            <FormField
                label={<FormattedMessage id="creative.creator.ur" defaultMessage="No Event Found" />}
                inputId="creative-creator-landing-page"
                labelContainerClass={styles['label-container']}
                containerClass={styles['text']}
                subDescription={
                    <FormattedMessage
                        id="creative.creator"
                        defaultMessage="Add events from your website without coding"
                    />
                }
                descriptionClass={styles['description']}
            >
                <div className={styles['button']}>
                    <Button
                        onClick={onStartCreate}
                        variant={Button.variant.primary}
                        size={Button.size.md}
                        aria-label="New Event"
                    >
                        <span className={styles['plus-icon']}>+</span>
                        <FormattedMessage id="creative.creator.urls.button" defaultMessage="New Event" />
                    </Button>
                </div>
            </FormField>
        </div>
    );
};
